/* eslint-disable */
/*
* Accessory visualizer library provided by Insignia
* Consumes Insignia data to display vehicles with different colors, at different angles, and with accessories on them.
*
* RevolutionParts changelog from original library file
* - Wrapped to enable modularization and control when the IIFEs are activated.
* - Anywhere with "NOTE: RP -"
* - Changed usages of "images/empty.gif" to "https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif"
*/


module.exports = function visualizerConfig() {
	const $ = rp$; // NOTE: RP - remapping $ to rp$ in this scope

// ...configure support for dynamic resizing
	(function (jQuery, sr) {  // NOTE: RP - jQuery param was $, not correct
		// debouncing function from John Hann
		// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		var debounce = function (func, threshold, execAsap) {
			var timeout;
			return function debounced() {
				var obj = this, args = arguments;

				function delayed() {
					if (!execAsap)
						func.apply(obj, args);
					timeout = null;
				};
				if (timeout)
					clearTimeout(timeout);
				else if (execAsap)
					func.apply(obj, args);
				timeout = setTimeout(delayed, threshold || 100);
			};
		};

		// ...smartresize
		jQuery.fn[sr] = function (fn) {
			return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
		};
	})(rp$, 'smartresize'); // NOTE: RP - passing in rp$ instead of jQuery

// Insignia JS-Configurator, Copyright (c) 2012-2020
// config.js
// REQUIRES:
//		JQuery 1.7.2 or later
//		Accompanying config.css
// ASSUMES:
//		Existence of <div id="igConfigurator"></div> within which all content is managed.
//		You can style this for placement but be careful of styles that 'reach inside' to do stuff!

	return (function () {
		var cfgScalerID = '#configuratorScaler';
		var cfgContainerID = '#configurator';
		var cfgColorsID = '#configuratorColors';
		var cfgColorNameID = '#configuratorColorName'; // NOTE: RP - added for color name support
		var colorSelectorClass = 'configuratorColor';
		var cfgRotatorID = '#configuratorRotator';
		// BES 9/4/18: This differs from Kevin's version and is necessary!
		var cfgRotatorContainerID = '#configuratorRotatorContainer';
		// BES 9/4/18
		var rotatePrevSel = cfgRotatorID + ' img.rot.prev';
		var rotateNextSel = cfgRotatorID + ' img.rot.next';
		var maskClass = 'mask';
		var selectedClass = 'selected';
		var visibleClass = 'visible';
		var hiddenClass = 'hidden';
		var vehAssetClass = 'configuratorLayer';
		var vehDecalClass = 'decalLayer';
		var viewSetClass = 'configuratorViewSet';
		var viewClass = 'configuratorView';
		var positionClass = 'configuratorHotspotPosition';
		var canvasOffsetClass = 'canvas-offset';
		var assetPartClass = 'asset-part';
		var dotClass = 'configuratorDot';
		// var clippingMaskClass = "clippingMask";
		var maxZIndex = 0;
		var assetX = 850; // default META asset width- be careful where used below! - kr
		var assetY = 400; // default META asset height- be careful where used below! - kr
		// var rgb;

//////////////////////////////////////////////////////
//// One-time initialization
//////////////////////////////////////////////////////

		var calcMatrixScale = function () {
			// ...calculate the tMatrix scaling factor
			//		Configurator assets are always assetXx400
			//		var assetX = 850;
			//		var assetY = 400;
			var aspect = assetX / assetY; // 850/400 = 2.125
			var xView = $(cfgScalerID).innerWidth();
			var yView = $(cfgScalerID).innerHeight();
			var factor = 1;
			if (xView / yView >= aspect) // 2.431372549019608
				factor = yView / assetY; // 0.3
			else
				factor = xView / assetX;
			if (factor <= 1) {
				// ...calculate the scale
				var scale = factor.toString() + ',' + factor.toString();
				$(cfgContainerID).css({
					'transform': 'scale(' + scale + ')',
					'margin-left': '0', // NOTE: RP - ensure no left margin is default
				});
				// ...now center it
				var xlate = (xView - factor * assetX) / 2;
				// NOTE: RP - commenting out if block as it does more harm than good in our use case
				if (xlate > 0) {
					$(cfgContainerID).css({
						'margin-left': xlate,
					});
				}
			} else /*if (factor == 1)*/ {
				// ...in case it wasn't, scale it to 1!
				$(cfgContainerID).css({
					'transform': 'scale(1,1)',
					'margin-left': '0', // NOTE: RP - ensure no left margin is default
				});
			}
		};

		$(window).smartresize(function () {
			resized();
		});

		var resized = function () {
			calcMatrixScale();
		};

		// ...stores the callback to make when a part is removed
		var onPartsRemovedCallback;

////////////////////////////////////////////////////
// Vehicle-Configurator...
////////////////////////////////////////////////////

		var loadVehicleCore = function (vehicleJSON, initialRGB, partsRemovedCallback) {
			// vehicleJSON is an object in this format:
			// {
			//   colors: [],
			//   viewsets: []
			// }
			onPartsRemovedCallback = partsRemovedCallback;
			clearContainers();
			calcMatrixScale();
			setupRotate();
			popColors($(cfgColorsID), vehicleJSON.colors);

			// BES 9/4/18: This differs from Kevin's version and is necessary!
			$(cfgRotatorContainerID).show();

			// BES 9/4/18
			popViewSets($(cfgContainerID), vehicleJSON.viewsets);

			// ...do we need to pre-select a color?
			if (initialRGB) {
				$('.' + colorSelectorClass).removeClass(selectedClass);
				$('.' + colorSelectorClass + '[rgb=' + initialRGB + ']').addClass(selectedClass);
			}
			setVehToSelectedColor();
			$('#configuratorBrag').text(vehicleJSON.patent);
		};

		var clearContainers = function () {
			$(cfgContainerID).children().remove();
			$(cfgColorsID).children().remove();
		};

////////////////////////////////////////////////////
// Vehicle-Colors...
////////////////////////////////////////////////////

		var popColors = function (container, colors) {
			// colors is an array of color-objects in this format:
			// [
			//   {
			//     id:
			//     name:
			//     rgb:
			//     oemCode:
			//   } ...
			// ]
			for (var i = 0; i < colors.length; ++i)
				popColor(container, colors[i]);

			// ...wire up the color-click event
			$('.' + colorSelectorClass).on('click', function (e) { // NOTE: RP - remove deprecated jquery inline event/alias
				$('.' + colorSelectorClass).removeClass(selectedClass);
				$(this).addClass(selectedClass);
				setVehToSelectedColor();
			});
		};

		var popColor = function (container, color) {
			// color is an object in this format:
			// {
			//   id:
			//   name:
			//   rgb:
			//   oemCode:
			// }
			var elem = newDivInContainer(container, colorSelectorClass, selectedClass);
			elem.attr({
				'title': color.name,
				'rgb': color.rgb,
			});
			elem.css({
				'background-color': '#' + color.rgb,
			});
			elem.html('<span>' + color.name + '</span>');
		};

		var selectedRGB = function (colorSelectorClass, selectedClass) {
			var rgb = $('.' + colorSelectorClass + '.' + selectedClass).attr('rgb');
			return rgb;
		};

		var setVehToSelectedColor = function () {
			var rgb = selectedRGB(colorSelectorClass, selectedClass);
			setVehicleColor(rgb);
			setColorText(); // NOTE: RP - added this call
		};

		// NOTE: RP - Added this function
		var setColorText = function () {
			var selectedColorName = $('.' + colorSelectorClass + '.' + selectedClass).attr('title');
			var colorNameEl = $(cfgColorNameID);
			colorNameEl.text(selectedColorName);
		};

		var setVehicleColor = function (rgb) {
			// ...finds all elemnts with class=mask inside a visible view...pixastic/canvas coloring cannot happen on hidden elements
			// * * * DO NOT COMBINE THESE LOOPS! * * *
			var vizMasks = $('.' + viewSetClass + '.' + visibleClass + ' .' + viewClass + '.' + visibleClass + ' .' + maskClass);
			vizMasks.each(function (index, div) {
				var img = div.children[0];
				Pixastic.revert(img);
			});
			vizMasks.each(function (index, div) {
				var img = div.children[0];
				setImgColor(img, $(this).attr('rgb') || rgb, $(this).attr('anchor'));
			});

			// * * * DO NOT COMBINE THESE LOOPS! * * *
			var partMasks = $('.' + viewSetClass + '.' + visibleClass + ' .' + viewClass + '.' + visibleClass + ' ' + 'div[partid]');
			partMasks.each(function (index, div) {
				var imgDOM = div.children[0];
				Pixastic.revert(imgDOM);
			});
			partMasks.each(function (index, div) {
				var imgDOM = div.children[0];
				setImgColor(imgDOM, $(this).attr('rgb') || rgb, $(this).attr('anchor'),
					function () {
						processCanvasToSVG($(div).find('canvas'));
					});
			});
		};

		var setImgColor = function (domImg, rgb, anchor, callback) {
			if (rgb.charAt(0) === '#')
				rgb = hex.substring(1, 7);
			var R = parseInt(rgb.substring(0, 2), 16);
			var G = parseInt(rgb.substring(2, 4), 16);
			var B = parseInt(rgb.substring(4, 6), 16);
			var magic = 255;
			Pixastic.process(domImg, 'coloradjust', {
				red: (R - anchor) / magic,
				green: (G - anchor) / magic,
				blue: (B - anchor) / magic,
			}, callback);
		};

		var processCanvasToSVG = function ($canvas) {
			// ...given a canvas JQuery object, process its URI to the right SVG
			if ($canvas.length > 0) {
				var canvasDom = $canvas.get(0);
				var $svg = $canvas.parent().siblings('svg');
				var canvasDiv = $canvas.parent('div');
				var colorizedImageUrl = canvasDom.toDataURL();
				var partID = canvasDiv.attr('partid') || 'asset';
				var gImageClass = canvasDiv.attr('gImageClass');
				$svg.find('image.' + gImageClass).attr({
					'xlink:href': colorizedImageUrl,
					'partid': partID,
					'width': canvasDom.width,
					'height': canvasDom.height,
				});
				// $("div." + positionClass).find("div").remove();
			}
		};

////////////////////////////////////////////////////
// Vehicle-Views...
////////////////////////////////////////////////////

		var popViewSets = function (container, viewsets) {
			// viewsets is an array of view-objects in this format:
			// [
			//   {
			//     name:
			//     views: []
			//   } ...
			// ]
			// ...view-rotation may be disabled - i.e. there's only one view!
			$(cfgRotatorID).hide();
			for (var i = 0; i < viewsets.length; ++i)
				popViewSet(container, viewsets[i]);
		};

		var popViewSet = function (container, viewset) {
			// viewset is an object in this format:
			// {
			//   name:
			//   views: []
			// }
			var elem = newDivInContainer(container, viewSetClass, visibleClass);
			elem.attr('name', viewset.name);
			if (viewset.views.length > 1)
				$(cfgRotatorID).show();
			for (var i = 0; i < viewset.views.length; ++i)
				popView(elem, viewset.views[i]);
		};

		var popView = function (container, view) {
			// viewset is an object in this format:
			// {
			//   angle:
			//   assets: {}
			//   hotspots: []
			// }
			var viewContainer = newDivInContainer(container, viewClass, visibleClass);
			viewContainer.attr('angle', view.angle);

			// ...load the vehicle assets
			var maskElement = null;
			if (view.assets)
				maskElement = popVehAssets(viewContainer, view.assets);

			// ...load the hotspots
			for (var i = 0; i < view.hotspots.length; ++i)
				popHotSpot(viewContainer, maskElement, view.hotspots[i], view.angle);
		};

		var popVehAssets = function (container, assets) {
			// assets is an object in this format:
			// {
			//   anchor:
			//   decalUrl:
			//   imageUrl:
			//   maskUrl:
			// }

			// ... if there is an asset image
			if (assets.imageUrl) {
				var elem = newDivInContainer(container, vehAssetClass);
				newImgInContainer(elem, assets.imageUrl);
			}

			// ... if there is a mask image
			var maskElement = null;
			if (assets.maskUrl) {
				var elem = maskElement = newDivInContainer(container, vehAssetClass);
				elem.addClass(maskClass);
				if (assets.anchor)
					elem.attr('anchor', assets.anchor);
				newImgInContainer(elem, assets.maskUrl);
			}

			// ...if there is a decal image
			if (assets.decalUrl) {
				var elem = newDivInContainer(container, vehAssetClass);
				elem.addClass(vehDecalClass);
				newImgInContainer(elem, assets.decalUrl);
			}

			// ...return the element we placed the maskUrl in
			return maskElement;
		};

		var popHotSpot = function (container, maskElement, hotspot, angle) {
			// hotspot is an object in this format:
			// {
			//   anchor:
			//   positions: []
			// }

			// TODO: This should be a property of the hotspot
			var positionBeforeDecal = maskElement && (hotspot.name === 'WindowTint' || hotspot.name === 'WindowFilmWindshieldFull' || hotspot.name === 'WindowFilmWindshieldPartial' || hotspot.name === 'WindowFilmFront' || hotspot.name === 'WindowFilmRear');
			var hotspotContainer = newDivInContainer(container);
			hotspotContainer.attr('name', hotspot.name);
			if (positionBeforeDecal) {
				hotspotContainer.insertAfter(maskElement);
			}

			// ...check if the LiftKits hotspot exists - kr
			var hasHotspotToTransform = hotspot.name.indexOf('Lift') != -1; // looks for the string 'Lift' and returns its index, or -1 if not found
			for (var i = 0; i < hotspot.positions.length; ++i) {
				var svgMaskID = ('a' + angle + '-' + hotspot.name + '-svg-mask' + (i + 1));
				popPosition(hotspotContainer, hotspot.positions[i], positionBeforeDecal, svgMaskID, hasHotspotToTransform);
			}
		};

		var popPosition = function (container, position, suppressZIndex, svgMaskID, hasHotspotToTransform) {
			// position is an object in this format:
			// {
			//   name: Optional sub-hotspot-name
			//   zindex:
			//   tmatrix:
			//   clippingMaskUrl: Optional vector mask
			//   assets: {} Optional inital image
			// }

			// ...a position is a sub-hotspot. It is likely transformed, and it could have a clipping mask. Clipping masks are NOT transformed. If there is one we need to create a <mask> element with an unique ID to place it in, then call the mask within an svg <g> that references that <mask>	- kr
			var elem;
			elem = newDivInContainer(container, positionClass);
			if (position.name)
				elem.attr('name', position.name);
			//if (!suppressZIndex) // Commented out - not sure what they're doing. The correct z-index for the Passenger side Front/Rear Films gets passed via the json - kr
			if (position.zindex) {
				elem.css('z-index', position.zindex);
				if (position.zindex > maxZIndex)
					maxZIndex = position.zindex;
			}

			// ...create entire svg inside configuratorHotspotPosition DIV to avoid dealing with namespace stuff - kr
			var hotspotPositionSVG = $('<!-- begin SVG for part --><svg  xmlns="http:\/\/www.w3.org\/2000\/svg" xmlns:xlink="http:\/\/www.w3.org\/1999\/xlink" x=\'0\' y=\'0\' width=\'850\' height=\'400\' class=\'hotspot-position-svg\'><!-- if needed, this group is for overall transform for lifted/lowered parts --><g class=\'transform-g\'><!-- if needed, mask is called over transformed part --><g class=\'mask-g\'><!-- if needed, default asset part is shown. Then hidden when a part is selected. Asset parts are always 850x400, so they are outside the tmatrix --><g class=\'asset-part-g\'><image class=\'asset-part-image\' x=\'0\' y=\'0\' xlink:href=\'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif\' viewBox=\'0 0 850 400\' width=\'0\' height=\'0\' /><image class=\'asset-part-image-mask\' x=\'0\' y=\'0\' xlink:href=\'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif\' viewBox=\'0 0 850 400\' width=\'0\' height=\'0\' /></g><!-- end asset part --><!-- begin part being masked --><!-- actual parts have to be transformed before mask is placed --><g class=\'part-g\'><image class=\'svg-part-image\' x=\'0\' y=\'0\' xlink:href=\'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif\' viewBox=\'0 0 850 400\'width=\'0\' height=\'0\' /><image class=\'svg-part-image-mask\' x=\'0\' y=\'0\' xlink:href=\'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif\' viewBox=\'0 0 850 400\'width=\'0\' height=\'0\' /></g><!-- end part being masked --></g><!-- end group for part mask --></g><!-- end group for transform --><!-- mask definition/image --><defs><g class=\'mask-image-g\'><mask><!-- adding rect for expanded so that just attributes need to be changed in the js, lame, I know - kr --><rect x=\'0\' y=\'0\' height=\'0\' width=\'0\' style=\'stroke:#ffffff; fill: #ffffff\' /><!-- end rectangle for mask --><image class=\'svg-mask-image\' xlink:href=\'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif\' x=\'0\' y=\'0\' viewBox=\'0 0 850 400\'width=\'0\' height=\'0\' /></mask></g></defs><!-- end mask definition/image --></svg><!-- end SVG for part -->'); // Don't need to put w/h of '0' in either <image> tag since if they are not defined in SVG they go to 0 automatically - kr
			var maskDef = hotspotPositionSVG.find('g.mask-image-g mask');
			var maskImage = hotspotPositionSVG.find('mask image');

			// ...declare variables
			var deltaX = 0, deltaY = 0, assetXNew, assetYNew; // if configurator expands outside 850 x 400
			if (position.tmatrix) {
				// var deltaX ="0", deltaY = "0", assetXNew, assetYNew; // if configurator expands outside 850 x 400
				// ...reading the tmatrix and placing into an array
				var tMatrix = position.tmatrix;
				var tMatrixArray = [];
				tMatrixArray = tMatrix.split(',');
				for (var i = 0, max = tMatrixArray.length; i < max; i++) {
					tMatrixArray[i] = parseFloat(tMatrixArray[i]);
				}

				// ...last two values of the array are the translate x,y
				var xTranslate = tMatrixArray[4];
				var yTranslate = tMatrixArray[5];
				// var transformedHotspot = position.name.indexOf("Lift")!=-1 ;
				if (xTranslate < 0) {
					// ...x below 0 means expand to left, SVG larger than 850w
					deltaX = -xTranslate;

					// ...expand width of configurator by deltaX value
					assetXNew = deltaX + assetX;

					// ...update svg attributes
					hotspotPositionSVG.attr({
						'width': assetXNew,
						'viewBox': '0 0 ' + assetXNew + ' ' + assetY + '',
						'style': 'transform: translate(' + -deltaX + 'px, 0)',
					});

					// ...update tmatrix and apply to Part group
					tMatrixArray.splice(4, 1, '0'); // change x-translate [4th value] to 0
					tMatrix = tMatrixArray.join();

					// modify svg rect to fill difference in with white
					maskDef.find('rect').attr({
						'height': assetY,
						'width': deltaX,
					});

					// ...update svg mask
					maskImage.attr('x', deltaX);

				} else if (yTranslate < 0) {
					// ...y below 0 means expand on top, SVG taller than 400h
					deltaY = -yTranslate;
					assetYNew = (deltaY + assetY);

					// ...update svg attributes
					hotspotPositionSVG.attr({
						'height': assetYNew,
						'viewBox': '0 0 ' + assetX + ' ' + assetYNew + '',
						'style': 'transform: translate(0,' + -deltaY + 'px)',
					});

					// ...update tmatrix, applied to part image group after if/else statements
					tMatrixArray.splice(5, 1, '0'); // change y-translate [5th value] to 0
					tMatrix = tMatrixArray.join();

					// ...modify svg rect to fill difference in with white
					maskDef.find('rect').attr({
						'height': deltaY,
						'width': assetX,
					});

					// ...update svg mask
					maskImage.attr('y', deltaY);

				} else if (xTranslate >= 425) {
					// ...x above 425 means expand to right
					deltaX = xTranslate - 425;
					assetXNew = (deltaX + assetX);

					// ...update svg attributes
					hotspotPositionSVG.attr({
						'width': assetXNew,
						'viewBox': '0 0 ' + assetXNew + ' ' + assetY + '',//,
						//"style"		: "transform: translateY("+ -deltaX +"px)"
					});

					// ...modify svg rect to fill difference in with white
					maskDef.find('rect').attr({
						'x': 850,
						'height': assetY,
						'width': deltaX,
					});

				} else {
					// TODO: other if/else for bottom
					// hotspotPositionSVG.attr("viewBox", "0 0 " + assetX + " " + assetY + "");
				}

				// ...add tmatrix to the part image group
				hotspotPositionSVG.find('g.part-g').attr('transform', 'matrix(' + tMatrix + ')');
			}

			// ...update svg mask element when clippingMaskURL is present
			//		Masks are 850 x 400 by default, but can be larger when needed - for roof racks extending above or trailers behind the vehicle, for example
			if (position.clippingMaskUrl) {
				var groupWithMask, maskDef, maskImage;

				// ...add mask ID to containing <g> tag
				groupWithMask = hotspotPositionSVG.find('g.mask-g');
				groupWithMask.attr('style', 'mask: url(#' + svgMaskID + ');');

				// ...corresponding mask ID to mask definition
				maskDef.attr('id', svgMaskID);

				// ...mask image
				maskImage.attr({
					'xlink:href': position.clippingMaskUrl,
					'width': assetX,
					'height': assetY,
				});

				// ...add tmatrix to the part image group
				// hotspotPositionSVG.find("g.part-g").attr("transform", "matrix(" + tMatrix + ")");
			}

			var assets = position.assets;
			if (assets) {
				// ...is there an image?
				var assetPartImage;
				if (assets.imageUrl) {
					// ...add imageUrl, w/h to <image> element for asset
					assetPartImage = hotspotPositionSVG.find('.asset-part-image').attr({
						'xlink:href': assets.imageUrl,
						'partid': 'asset',
						'width': assetX,
						'height': assetY,
					});
				}

				// ...do we need to set a color?
				if (assets.maskUrl) {
					// Creates DIV container and adds: partid, anchor, maskClass, rgb if needed
					var div = newDivInContainer(elem, assetPartClass);
					div.attr({
						'gImageClass': 'asset-part-image-mask',
						'partid': 'asset',
						'anchor': assets.anchor,
					});
					// div.addClass(maskClass);
					div.addClass(maskClass + ' ' + canvasOffsetClass);

					// ...if the part has its own color
					if (assets.rgb) {
						div.attr('rgb', assets.rgb);
					}

					var img = newImgInContainer(div, assets.maskUrl);
					var imgDOM = $(img).get(0);
					var rgbToSet = div.attr('rgb') || $('.' + colorSelectorClass + '.selected').attr('rgb');
					setImgColor(imgDOM, rgbToSet, div.attr('anchor'), function () {
						processCanvasToSVG(div.find('canvas'));
					});
				}

				if (assets.imageUrl && assets.maskUrl) {
					// $("g.part-g").prepend("<image class='svg-part-image' x='0' y='0' xlink:href='https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif' viewBox='0 0 850 400'></image>"); // this won't work w/o dealing with namespace which i don't really want to do. added to main svg block instead - kpr
					assetPartImage = hotspotPositionSVG.find('.asset-part-image').attr({
						'xlink:href': assets.imageUrl,
						'partid': 'asset',
						'width': assetX,
						'height': assetY,
					});
				}
			}

			if (hasHotspotToTransform) {
				// ...set asset part to bottom of config
				hotspotPositionSVG.find('g.asset-part-g').attr('transform', 'translate(' + deltaX + ' ' + deltaY + ')');
			}
			// setTransformAsset = function(){
			// };
			elem.append(hotspotPositionSVG);
			return;
		};

		var newDivInContainer = function (container, className, firstClassName) {
			var elem = $('<div></div>');

			// ...is there a class to apply?
			if (className)
				elem.addClass(className);

			// ...is there a class to apply if this is the FIRST child?
			if (firstClassName)
				if (container.children().length < 1)
					elem.addClass(firstClassName);
			container.append(elem);
			return $(elem);
		};

		var newImgInContainer = function (container, url) {
			var elem = $('<img/>');
			elem.attr('src', url);
			container.append(elem);
			return elem;
		};

////////////////////////////////////////////////////
// View-Rotation...
////////////////////////////////////////////////////

		var setupRotate = function () {
			$(rotateNextSel).unbind().on('click', rotateNext); // NOTE: RP - remove deprecated jquery inline event/alias
			$(rotatePrevSel).unbind().on('click', rotatePrev); // NOTE: RP - remove deprecated jquery inline event/alias

			// ...jQuery-mobile events - work fine with custom jquery-mobile.js - kpr
			// ...for retail catalog configurator
			$(cfgContainerID).on('swiperight', rotateNext);
			$(cfgContainerID).on('swipeleft', rotatePrev);

			// ...for the LLumar site [since the rotator arrows are on the outside edges]
			$(cfgRotatorID).on('swiperight', rotateNext);
			$(cfgRotatorID).on('swipeleft', rotatePrev);
		};

		var rotateNext = function (e) {
			e.stopPropagation();
			rotate($('.' + viewSetClass + '.' + visibleClass),
				function (viz) {
					return viz.next();
				},
				function (children) {
					return children.first();
				},
			);
		};

		var rotatePrev = function (e) {
			e.stopPropagation();
			rotate($('.' + viewSetClass + '.' + visibleClass),
				function (viz) {
					return viz.prev();
				},
				function (children) {
					return children.last();
				},
			);
		};

		var rotate = function (parentSel, next, wrap) {
			// ...'Rotate' .visible class thru children of parentSel
			var children = parentSel.children();
			var viz = children.filter('.' + visibleClass);
			viz.removeClass(visibleClass);
			var nxt = next(viz);
			if (0 === nxt.length)
				nxt = wrap(children);
			nxt.addClass(visibleClass);
			setVehToSelectedColor();
		};

////////////////////////////////////////////////////
// Add-Parts...
////////////////////////////////////////////////////

		var addPartsCore = function (parts, partsAddedCallback) {
			for (var i = 0; i < parts.length; i++) {
				addPart(parts[i]);
			}
			if (typeof partsAddedCallback === 'function') {
				partsAddedCallback();
			}
		};

		var addPart = function (part) {
			// ...are there any parts/images we need to remove first?
			if (removeConflictingParts(part)) {
				// ...loop on the views of the parts - all the angles
				var views = part.views;
				for (var i = 0; i < views.length; i++) {
					popPartView(part, views[i]);
				}
			}
			var partInTransformingHotspot = part.hotspot.indexOf('Lift') !== -1; // TODO: add additional names as needed
			if (partInTransformingHotspot) {
				activateTransform(part.hotspot);
			}
		};

		var popPartView = function (part, view) {
			// ...populate a view (angle) of a part in a hotspot
			// ...view comes from the PART.
			var hotspotContainer = $(cfgContainerID + ' > [name=\'Exterior\'] > [angle=\'' + view.angle + '\'] > [name=\'' + part.hotspot + '\']');
			if (hotspotContainer.length > 0) {
				// ...loop on multiple positions (sub-hotspots) within a hotspot
				for (var i = 0; i < view.positions.length; i++) {
					popPartViewPosition(hotspotContainer, part, view, view.positions[i]);
				}
			}
		};

		var popPartViewPosition = function (container, part, view, position) {
			// What to do with position.angle?
			// 4/9/13: Nothing! The tmatrix in the vehicle hotspot-position already mirrors!
			// ...find positions within container (HotSpot). These may not be direct-children if there is a clipping mask.
			// TODO: This might not be right for one sub with a name and the other without??
			var hotspotPositions;

			// ...if position has a name, match that name
			if (typeof position.name !== 'undefined') {
				hotspotPositions = container.find('.' + positionClass + '[name=\'' + position.name + '\']');
				// ...otherwise, match the subhotspot w/o a name
			} else {
				hotspotPositions = container.find('.' + positionClass + ':not([name])');
			}

			// ...repeat for each sub-hotspot we found!
			hotspotPositions.each(function (index) {
				var hotspotPosition = $(this);
				var assets = position.assets;
				var partImage;
				if (assets) {
					// ...is there an image?
					if (assets.imageUrl) {
						// ...add imageUrl, w/h. partID to <image> element
						partImage = hotspotPosition.find('.part-g .svg-part-image').attr({
							'xlink:href': assets.imageUrl,
							'partid': part.id,
						});

						// ...loading image into DOM to get w/h for <image> then removing
						var hiddenImages = newImgInContainer($('.hidden-images'), assets.imageUrl);
						hiddenImages.on('load', function (e) {
							var hiddenImage = $(this).get(0);
							partImage.attr({
								'width': hiddenImage.width,
								'height': hiddenImage.height,
							});
							hiddenImages.remove();
						});
					}

					// ...do we need to set a color?
					if (assets.maskUrl) {
						// ...creates DIV container and adds: partid, anchor, maskClass, rgb if needed
						var div = newDivInContainer(hotspotPosition);
						div.attr({
							'gImageClass': 'svg-part-image-mask',
							'partid': part.id,
							'anchor': assets.anchor,
						});
						div.addClass(maskClass + ' ' + canvasOffsetClass);

						// ...if the part has its own color
						if (part.rgb) {
							div.attr('rgb', part.rgb);
						}

						var img = newImgInContainer(div, assets.maskUrl);
						var imgDOM = $(img).get(0);
						var rgbToSet = div.attr('rgb') || $('.' + colorSelectorClass + '.selected').attr('rgb');
						setImgColor(imgDOM, rgbToSet, div.attr('anchor'), function () {
							processCanvasToSVG(div.find('canvas'));
						});
					}

					// ...if there is an asset image and mask
					if (assets.imageUrl && assets.maskUrl) {
						// $("g.part-g").prepend("<image class='svg-part-image' x='0' y='0' xlink:href='https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif' viewBox='0 0 850 400'></image>"); // this won't work w/o dealing with namespace which i don't really want to do. added to main svg block instead - kpr
						partImage = hotspotPosition.find('.svg-part-image').attr({
							'xlink:href': assets.imageUrl,
							'partid': part.id,
							'width': $('.' + canvasOffsetClass + ' canvas').attr('width'),
							'height': $('.' + canvasOffsetClass + ' canvas').attr('height'),
						});
					}
					var assetPartGroup = hotspotPosition.find(' .asset-part-g'); // NOTE: RP - needed 'var'

					// NEW - hide only if it's not in a lifted hotspot
					var dontHide = $(this).parent('[name*=\'LiftKit\']');
					assetPartGroup.attr('partid', 'pre-' + part.id);
					if (dontHide.length) {
						assetPartGroup.show();
					} else {
						assetPartGroup.hide();
					}
				}
			});
		};

		var getPartIDInHotSpot = function (hotSpotName) {
			var existingParts = $('#configurator div[name=\'' + hotSpotName + '\'] image[partID]');
			if (existingParts.length > 0)
				return Number(existingParts.attr('partid'));
			return null;
		};

		var activateTransform = function (hotSpotName) {
			// Transform hotspots other than lift/lower hotspot that got added
			// ...get css transform value of the placed lifted/lowered part svg - kr
			var transformedSVG = $(cfgContainerID + ' div[name=\'' + hotSpotName + '\']').first().find('svg'); // just need the 1st one if all transform values are equal. maybe. - kr

			// ...grab inline css value determined above in popPosition.
			var transformValue = transformedSVG.attr('style');

			// ...getting via js will result in matrix transform value - kr
			var transRegex = /\.*translate\((.*)px\)/i;
			var xyTrans = transRegex.exec(transformValue)[1];

			// ...parse value grabbed from the svg to get the x/y values
			var transformValueArray = [];
			transformValueArray = xyTrans.split(',');
			for (var i = 0, max = transformValueArray.length; i < max; i++) {
				transformValueArray[i] = parseFloat(transformValueArray[i]);
			}

			// ...define x/y values
			var xTranslate = transformValueArray[0];
			var yTranslate = transformValueArray[1];

			// ...combine them for the css tranlate value
			var cssTranslate = 'translate(' + xTranslate + 'px ,' + yTranslate + 'px)';

			// ...apply x/y translate value to svg containers for everything except lift and wheels [removed below]
			// ...units or comma not needed inside the svg group
			$(cfgContainerID + ' div[name] .transform-g').attr('transform', 'translate(' + xTranslate + ' ' + yTranslate + ')');

			// ...then remove from lifts and wheels. Names are case sensitive. I'm sure there's better ways to do this - kr
			$(cfgContainerID + ' div[name*=\'Lift\'] .transform-g').removeAttr('transform');
			$(cfgContainerID + ' div[name*=\'Wheel\'] .transform-g').removeAttr('transform');

			// ...NEW - add transform to this svg's mask to move image up when placed - kr
			// ...units or comma not needed inside the svg group
			$(cfgContainerID + ' div[name=\'' + hotSpotName + '\'] mask image').attr('transform', 'translate(' + xTranslate + ' ' + yTranslate + ')');

			// ...NEW - add transform to this svg's mask rect to fill space when mask moved up - kr
			// ...units or comma not needed inside the svg group
			$(cfgContainerID + ' div[name=\'' + hotSpotName + '\'] mask rect').attr('y', '400');

			// TODO: other transformation directions like lowering?
			// ...NEW - add transform to inital vehicle asset layers (1st two) - kr
			$(cfgContainerID + ' .' + vehAssetClass + ':nth-child(-n+2)').css('transform', cssTranslate);

			// ...add transform to Decal layer - kr
			$(cfgContainerID + ' .' + vehDecalClass).css('transform', cssTranslate);

			// ...add transform to DOTS - kr
			$('.configuratorDot').css('transform', cssTranslate);
		};

		var removeTransformCore = function () {
			// Remove Transformed hotspots
			// ...remove transform values from transform <g>, DOTS, and decals  - kr
			$(cfgContainerID).find('.transform-g').removeAttr('transform');

			// ...remove transform values from mask image  - kr
			$(cfgContainerID + ' div[name*=\'Lift\'] mask image').removeAttr('transform');

			// ...set mask rect back to x=0,y=0  - kr
			$(cfgContainerID + ' div[name*=\'Lift\'] mask rect').attr('y', '0');

			// TODO: other transformation directions like lowering?
			// ...OK to remove attr since it's the only style here - kr
			$(cfgContainerID + ' .' + vehDecalClass).removeAttr('style');
			$(cfgContainerID + ' .' + vehAssetClass + ':nth-child(-n+2)').removeAttr('style');
			$('.configuratorDot').css('transform', ' ');
		};

////////////////////////////////////////////////////
// Remove-Parts...
////////////////////////////////////////////////////

		var removePartsCore = function (partIDs) {
			removeParts(partIDs, false);
		};

		var removeParts = function (partIDs, raiseEvent) {
			if (partIDs.length > 0) {
				for (var i = 0; i < partIDs.length; i++) {
					// ...don't raise the event yet!
					removePartByID(partIDs[i], false);
				}
				if (raiseEvent) {
					raiseRemoveEvent(partIDs);
				}
			}
		};

		var removePartByID = function (partID, raiseEvent) {
			$(cfgContainerID + ' .part-g image[partid =\'' + partID + '\']').attr({
				'xlink:href': 'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif',
				'height': '0',
				'width': '0',
			}).removeAttr('partid');

			// $(cfgContainerID + " .part-g image[partid ='" + partID + "']").attr("xlink:href", "https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif").removeAttr("partid width height");
			$('.' + positionClass + ' div[gimageclass = \'svg-part-image-mask\'][partid =\'' + partID + '\']').remove();
			$('.' + positionClass + ' [partid=\'pre-' + partID + '\']').show();
			if (raiseEvent) {
				raiseRemoveEvent([partID]);
			}
		};

		var raiseRemoveEvent = function (partIDs) {
			if (typeof onPartsRemovedCallback === 'function') {
				onPartsRemovedCallback(partIDs);
			}
		};

		var removeConflictingParts = function (part) {
			// ...given a part remove any existing parts that may be 'in the way', return true if it is ok to add this part
			// ...start off an array of part ID's to remove
			var removePartIDs = []; // NOTE: RP - needed 'var' keyword
			var removePartID = getPartIDInHotSpot(part.hotspot);
			if (removePartID) {
				// ...if the part is already there
				if (removePartID === part.id)
					return false;
				removePartIDs.push(removePartID);
			}

			// ...check the exclusions and remove any conflicting parts
			$.each(part.incompatibleWith, function (index, exclusion) {
				if (exclusion !== part.hotspot) {
					var removePartID = getPartIDInHotSpot(exclusion);
					if (removePartID) {
						if (removePartID === 'asset')
							removePartIDs.push(`${removePartID}:${exclusion}`);
						else
							removePartIDs.push(removePartID);
					}
				}
			});

			// 5.2.7 6/10/14 Mutex logic moved to server
			// ...now remove them
			removeParts(removePartIDs, true);

			// ...ok to add part!
			return true;
		};

		var removeAllPartsCore = function () {
			$(cfgContainerID + ' .part-g image[partid]').attr({
				'xlink:href': 'https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif',
				'height': '0',
				'width': '0',
			}).removeAttr('partid');

			// $(cfgContainerID + " .part-g image[partid]").attr("xlink:href", "https://cdn-static.revolutionparts.io/assets/modules/accessory_visualizer/empty.gif").removeAttr("partid width height");
			$('.' + positionClass + ' div[gimageclass = \'svg-part-image-mask\'][partid]').remove();
			$(cfgContainerID + ' .asset-part-g').show();
			removeTransformCore();
		};

////////////////////////////////////////////////////
// HotSpot-Indicators...A.K.A. "DOTS"
////////////////////////////////////////////////////

		var setIndicatorsCore = function (dotsJSON, dotClickedCallback) {
			$.each(dotsJSON, function () {
				var dot = this;
				var view = $('.' + viewClass + '[angle=' + dot.angle + ']');
				if (view.length > 0) {
					var dotElem = newDivInContainer(view, dotClass);
					dotElem.attr({
						'dbid': dot.id,
						'title': dot.name,
						'brandtypeids': dot.brandTypeIds,
					});
					dotElem.css({
						'position': 'absolute',
						'left': dot.x,
						'top': dot.y,
						'z-index': maxZIndex + 1,
					});
					if (dotClickedCallback) {
						dotElem.on('click', function (e) { // NOTE: RP - remove deprecated jquery inline event/alias
							dotClickedCallback($(this).attr('dbid'));
						});
					}
				}
			});
		};

////////////////////////////////////////////////////
// Public-Methods...
////////////////////////////////////////////////////

		return {
			// Loads a vehicle given a configurator JSON
			load				/*(vehicleJSON, initialRGB, partsRemovedCallback)*/: loadVehicleCore,

			// Load parts given a parts-list array JSON
			add					/*(partListJSON, partsAddedCallback)*/: addPartsCore,

			// Remove parts given partID array [ partid, partid, ...] to remove
			remove				/*(partIdListJSON)*/: removePartsCore,

			// Remove ALL parts from the vehicle
			removeAll			/*()*/: removeAllPartsCore,

			// Remove any transform that has been applied
			removeTransform		/*()*/: removeTransformCore,

			// Set up for "hotspot indicators" aka "Dots"
			setIndicators		/*(dotsJSON, dotClickedCallback)*/: setIndicatorsCore,
		};
	})();
}
